import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text } from 'react-native';

import {
  I18n,
  Navigation,
  NavBar,
  Container,
  ProfileAvatar,
  Utils,
  IconRow,
} from '../../components';
import { THEME, FONT, COLOR, __WEB__ } from '../../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { openCaseInfo } from '../../cases/actions';

function mapStateToProps(state, ownProps) {
  return {
    userProfile: state.entities.followers[ownProps.userId],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ openCaseInfo }, dispatch),
  };
}

export default memo(
  connect(
    mapStateToProps,
    null
  )((props) => {
    useEffect(NavBar.setup(props), []);
    useEffect(function () {
      Navigation.setButtons(
        {
          leftButtons: [NavBar.buttons.done],
        },
        props.componentId
      );
    }, []);
    return (
      <Container>
        <View style={styles.header}>
          <ProfileAvatar profile={props.userProfile} />
          <Text style={styles.headerText}>{props.userProfile?.fullName}</Text>
        </View>
        <IconRow
          imageSource={require('../../../../resources/icon-mobile-phone.png')}
          label="Mobile Phone"
          topBorder={true}
          value={Utils.formatPhone(props.userProfile?.phone)}
        />
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  header: {
    ...THEME.header,
    alignItems: 'center',
    paddingVertical: 25,
  },
  headerText: {
    ...THEME.headerText,
    marginTop: 10,
  },
});
